import * as types from './mutation-types'
const mutations = {
  [types.SET_FACTORS](state, data) {
    state.factors = data
  },
  [types.SET_YEAR](state, data) {
    state.year = data
  },
  [types.SET_QUESTIONTYPE](state, data) {
    state.questiontype = data
  },
  [types.SET_REGION](state, data) {
    state.region = data
  },
  [types.SET_DIFF](state, data) {
    state.diff = data
  },
  [types.SET_CART](state, data) {
    state.cart = data
  },
  [types.SET_CATALOG](state, data) {
    state.catalog = data
  },
  [types.SET_KPS](state, data) {
    state.kps = data
  },
  [types.SET_BOOKORKPS](state, data) {
    state.bookorkps = data
  },
  [types.SET_DEFAULTBOOK](state, data) {
    state.defaultbook = data
  },
  [types.SET_SINGLEORMULTI](state, data) {
    state.singleormulti = data
  },
  [types.SET_BOOK](state, data) {
    state.book = data
  },
  [types.SET_DIFFNAME](state, data) {
    state.diffname = data
  },
  [types.SET_QUESTIONTYPENAME](state, data) {
    state.questiontypename = data
  },
  [types.SET_PROVINCENAME](state, data) {
    state.provincename = data
  },

  [types.SET_TEXTBOOK_VERSION](state, data) {
    state.textbookVersion = data
  },
  [types.SET_GRADE](state, data) {
    state.grade = data
  },
  [types.SET_PAPER_TYPE](state, data) {
    state.paperType = data
  }
}

export default mutations
